import { CheckCircle2 } from "lucide-react";

export function GarvBoardTab({ tasks, markDone, onOpenFull }) {
  return (
    <div className="flex-1 overflow-y-auto p-3 space-y-2" data-testid="garv-board">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs uppercase tracking-wide text-[#68665E] font-semibold">Open reminders</span>
        <button className="text-xs text-[#C84B31] hover:underline" onClick={onOpenFull} data-testid="garv-open-board">Full board →</button>
      </div>
      {tasks.length === 0 ? <div className="text-sm text-[#A09E96] py-4 text-center">No open reminders. Ask GARV to create one!</div> : tasks.map((t) => (
        <div key={t.id} className="border border-[#E5E3DB] rounded p-2.5" data-testid={`garv-board-task-${t.id}`}>
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <div className="text-sm font-medium text-[#1A1A18]">{t.title}</div>
              <div className="text-xs text-[#68665E] mt-0.5">{t.assignee_name || "Unassigned"}{t.due_date ? ` · due ${t.due_date}` : ""}</div>
            </div>
            <button onClick={() => markDone(t.id)} title="Mark done" className="text-[#2F6F4E] shrink-0" data-testid={`garv-board-done-${t.id}`}><CheckCircle2 className="w-5 h-5" /></button>
          </div>
        </div>
      ))}
    </div>
  );
}
